"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const hopper_style_1 = __importDefault(require("../hopper.style"));
const hopper_action_1 = __importDefault(require("../hopper.action"));
const grid_1 = __importDefault(require("components/templates/grid"));
const hopper_column_1 = require("../hopper.column");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const hopper_mutation_component_1 = __importDefault(require("./hopper.mutation.component"));
const modal_1 = require("components/molecules/modal");
const svg_1 = require("components/atoms/svg");
const react_router_dom_1 = require("react-router-dom");
const authorization_1 = require("utils/authorization");
const debounces_1 = require("utils/debounces");
const Hopper = () => {
    const { dataGrid, dataStates, isLoading, isSuccess, isError, errorMessage } = (0, store_1.useAppSelector)(state => state.master.hopper);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const debouncedGetDataGrid = (0, debounces_1.useDebouncedCallback)((newDataStates) => {
        dispatch(hopper_action_1.default.getDataGrid(newDataStates));
    }, 1000, [dispatch]);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Master Data', 'Hopper');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                dispatch(hopper_action_1.default.getDataGrid(dataStates));
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, fullScreen]);
    const actionCellRender = (0, custom_cell_grid_1.actionCell)([
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(hopper_action_1.default.onClickMutation({ mutationMode: 'edit', dataItem: d })),
        },
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(hopper_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem: d })),
        }
    ]);
    const actionColumn = [{
            title: '',
            width: '70px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true
        }];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(hopper_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(hopper_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        debouncedGetDataGrid(newDataStates);
    };
    const onSortChange = (e) => {
        dispatch(hopper_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        debouncedGetDataGrid(newDataStates);
    };
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, isLoading: isLoading, title: 'Master Data Hopper', isAddNew: isAuthorized.change, onAddNew: () => dispatch(hopper_action_1.default.onClickMutation({ mutationMode: 'add' })) }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(hopper_action_1.default.getDataGrid(dataStates));
                    dispatch(hopper_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, errorMessage: errorMessage, onClose: () => dispatch(hopper_action_1.default.onCloseError()), style: { 'zIndex': 10 } }), (0, jsx_runtime_1.jsx)(hopper_mutation_component_1.default, {}), (0, jsx_runtime_1.jsx)(grid_1.default, { style: hopper_style_1.default.gridHeight, dataGrid: dataGrid, columns: actionColumn.concat(fullScreen ? hopper_column_1.HopperColumnFullWidthProps : hopper_column_1.HopperColumnProps), dataStates: dataStates, pageable: true, sortable: true, sort: dataStates.sort, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange, fullScreen: fullScreen })] }));
};
exports.default = Hopper;
